import { PriceType, UIMode } from "@/types/types";
import { Side } from "../data/api";

export const PriceTypeToQuantileKey: Record<PriceType, 'inferred_price' | 'inferred_ytm' | 'inferred_spread'> = {
  [PriceType.Price]: 'inferred_price',
  [PriceType.Ytm]: 'inferred_ytm',
  [PriceType.Spread]: 'inferred_spread',
}

export const PriceTypeLabel: Record<PriceType, string> = {
  [PriceType.Price]: 'Price',
  [PriceType.Ytm]: 'YTM',
  [PriceType.Spread]: 'Spread',
}

export const SideLabel: Record<Side, string> = {
  [Side.bid]: 'Bid',
  [Side.offer]: 'Offer',
  [Side.dealer]: 'Dealer',
}

export const RfqLabelMap: Record<UIMode, Record<Side, PriceType[]>> =  {
  [UIMode.HighYield]: {
    [Side.bid]: [PriceType.Price, PriceType.Ytm, PriceType.Spread],
    [Side.dealer]: [PriceType.Price],
    [Side.offer]: [PriceType.Price],
  },
  [UIMode.InvestmentGrade]: {
    [Side.bid]: [PriceType.Price, PriceType.Ytm, PriceType.Spread],
    [Side.dealer]: [PriceType.Spread],
    [Side.offer]: [PriceType.Spread],
  },
}